export const LCA_BROKEN_SUB_PRODUCT_REFERENCE_CODE =
  'lca_broken_sub_product_reference';

export const getLcaApiErrorDetail = (error: unknown) =>
  (
    error as {
      response?: { data?: { detail?: string | { message?: string } } };
    }
  )?.response?.data?.detail;

export const getLcaApiErrorMessageKey = (error: unknown) => {
  const detail = getLcaApiErrorDetail(error);
  if (detail === LCA_BROKEN_SUB_PRODUCT_REFERENCE_CODE) {
    return 'errors.brokenSubProductReference';
  }
  return null;
};

export const getLcaApiErrorMessage = (
  error: unknown,
  t: (_key: string) => unknown
) => {
  const key = getLcaApiErrorMessageKey(error);
  if (!key) return null;
  const message = t(key);
  return typeof message === 'string' ? message : key;
};
